<div class="customer-wallet-shell">
  <div class="container fw-b wrapper-content">
    <app-linker-route
      [headingName]="headingName"
      [linkerRouteItems]="linkerRouteItems"
    ></app-linker-route>
  </div>

  <section class="container wallet-hero">
    <div class="hero-container-card">
      <div class="hero-cards-wrapper">
        <div class="hero-stat-card wallet-card">
          <div class="card-accent-strip wallet-accent"></div>
          <div class="card-content">
            <div class="card-icon-wrapper wallet-icon">
              <i class="fa fa-credit-card" aria-hidden="true"></i>
            </div>
            <p class="stat-amount">
              {{
                (wallet?.walletAmount &&
                  getPrice(wallet?.walletAmount | currency : 'ZAR' : 'R')) ||
                  'R 0.00'
              }}
            </p>
            <label class="stat-label">WALLET BALANCE</label>
            <button class="btn add-wallet-btn" (click)="openModal()">
              <i class="fa fa-plus me-2"></i>
              Add money to wallet
            </button>
          </div>
        </div>
        <div class="hero-stat-card records-card">
          <div class="card-accent-strip records-accent"></div>
          <div class="card-content">
            <div class="card-icon-wrapper records-icon">
              <i class="fa fa-list" aria-hidden="true"></i>
            </div>
            <p class="stat-amount">{{ count || 0 }}</p>
            <label class="stat-label">RECORDS LOADED</label>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="container wallet-table-section">
    <article class="transaction-table-card">
      <div class="table-header">
        <div>
          <p class="section-eyebrow">Transactions</p>
          <h2>Wallet activity</h2>
        </div>
        <span class="badge-counter">{{ count || 0 }} records</span>
      </div>

      <div class="table-responsive">
        <table class="table modern-table">
          <thead>
            <tr>
              <th scope="col">Serial No.</th>
              <th scope="col">From Wallet</th>
              <th scope="col">To Wallet</th>
              <th scope="col">Amount in R</th>
              <th scope="col">Transaction ID</th>
              <th scope="col">Status</th>
              <th scope="col">Transaction Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of orderList
                  | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: count
                      };
                let i = index
              "
            >
              <td data-label="Serial No.">{{ 10 * (currentPage - 1) + i + 1 }}</td>
              <td data-label="From Wallet">
                <div class="wallet-tag">
                  <ng-container *ngIf="item?.fromWalletType == 'OZW'">
                    <span class="wallet-name">OZOW Payment</span>
                    <span class="wallet-type">({{ item?.fromWalletType }})</span>
                  </ng-container>
                  <ng-container *ngIf="item?.fromWalletType == 'PAYGATE'">
                    <span class="wallet-name">PAYGATE Payment</span>
                    <span class="wallet-type">({{ item?.fromWalletType }})</span>
                  </ng-container>
                  <ng-container *ngIf="item?.fromWalletType == 'YOCO'">
                    <span class="wallet-name">YOCO Payment</span>
                    <span class="wallet-type">({{ item?.fromWalletType }})</span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      item?.fromWalletType != 'OZW' &&
                      item?.fromWalletType != 'PAYGATE' &&
                      item?.fromWalletType != 'YOCO'
                    "
                  >
                    <span class="wallet-name">{{ item?.fromUser?.firstName }} {{ item?.fromUser?.lastName }}</span>
                    <span class="wallet-type">({{ item?.fromWalletType }})</span>
                  </ng-container>
                </div>
              </td>
              <td data-label="To Wallet">
                <div class="wallet-tag">
                  <ng-container *ngIf="item?.toWalletType == 'OZW'">
                    <span class="wallet-name">OZOW Payment</span>
                    <span class="wallet-type">({{ item?.toWalletType }})</span>
                  </ng-container>
                  <ng-container *ngIf="item?.toWalletType == 'PAYGATE'">
                    <span class="wallet-name">PAYGATE Payment</span>
                    <span class="wallet-type">({{ item?.toWalletType }})</span>
                  </ng-container>
                  <ng-container *ngIf="item?.toWalletType == 'YOCO'">
                    <span class="wallet-name">YOCO Payment</span>
                    <span class="wallet-type">({{ item?.toWalletType }})</span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      item?.toWalletType != 'OZW' &&
                      item?.toWalletType != 'PAYGATE' &&
                      item?.toWalletType != 'YOCO'
                    "
                  >
                    <span class="wallet-name">{{ item?.toUser?.firstName || '--' }} {{ item?.toUser?.lastName }}</span>
                    <span class="wallet-type">({{ item?.toWalletType }})</span>
                  </ng-container>
                </div>
              </td>
              <td
                data-label="Amount in R"
                [ngClass]="
                  item?.toUser?._id == myId ? 'text-success' : 'text-theme-negative'
                "
              >
                {{ item?.toUser?._id == myId ? '+' : '-' }}
                {{
                  (item?.transactionAmount &&
                    getPrice(
                      item?.transactionAmount | currency : 'ZAR' : 'R'
                    )) ||
                    '--'
                }}
              </td>
              <td data-label="Transaction ID">{{ item?._id }}</td>
              <td data-label="Status">
                <span
                  class="status-chip"
                  [ngClass]="[
                    item?.transactionStatus,
                    (item?.transactionStatus || '').toLowerCase()
                  ]"
                >
                  {{ item?.transactionStatus }}
                </span>
              </td>
              <td data-label="Transaction Date">{{ item?.createdAt | date : 'medium' || '--' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        *ngIf="orderList?.length === 0 && !isLoading"
        class="empty-state text-center"
      >
        <p class="text-muted mb-3">
          No wallet transactions yet. Once you add money or make a purchase,
          your transaction history will appear here.
        </p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="bi bi-receipt"
          width="58"
          height="58"
          fill="lightgray"
          viewBox="0 0 16 16"
        >
          <path
            d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27m.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0z"
          />
          <path
            d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a .5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
          />
        </svg>
      </div>

      <app-table-loader
        *ngIf="isLoading"
        [isTable]="'TABLE'"
        [isLoading]="isLoading"
        [notFoundData]="notFoundData"
        [colspan]="7"
        [isWidth]="'55px'"
      >
      </app-table-loader>

      <div class="transaction-table-footer" *ngIf="count > 10">
        <pagination-controls (pageChange)="changePageNumber($event)"></pagination-controls>
      </div>
    </article>
  </section>
</div>

<div
  class="modal fade"
  id="addMoneyModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered wallet-modal" role="document">
    <div class="modal-content wallet-modal__content">
      <div class="wallet-modal__header">
        <div class="wallet-modal__logo-wrapper">
          <img
            class="wallet-modal__logo"
            src="assets/img/whiteLogo.png"
            alt="Exobe"
          />
        </div>
        <button
          type="button"
          class="wallet-modal__close"
          data-dismiss="modal"
          aria-label="Close"
        >
          ×
        </button>
      </div>
      <div class="wallet-modal__body">
        <div class="row justify-content-center">
          <div class="col-12 mb-2">
            <!-- Label added above the input box -->
            <label for="amount" class="form-label">Amount (in R)</label>
            <input
              type="number"
              id="amount"
              placeholder="Enter amount to add"
              [(ngModel)]="amount"
              max="999999"
              class="form-control"
            />
            <div class="for-validation mb-4">
              <!-- Show error message for 'required' if the field is touched and not filled -->
              <div class="for-validation text-danger" *ngIf="amount > 999999">
                *Amount cannot be greater than 999999.
              </div>
              <div class="for-validation text-danger" *ngIf="amount <= 0">
                *Invalid Amount.
              </div>
            </div>
          </div>
          <b class="col-12 text-center">Select Payment Method</b>
          <div class="payment-method col-4 mt-3">
            <input
              type="radio"
              (change)="getPayamnetMethod('paygate')"
              id="credit-card"
              name="payment"
              value="paygate"
            />
            <label for="credit-card">PayGate</label>
          </div>
          <div class="payment-method col-4 mt-3">
            <input
              type="radio"
              id="paypal"
              (change)="getPayamnetMethod('ozow')"
              name="payment"
              value="ozow"
            />
            <label for="paypal">Ozow</label>
          </div>
          <div class="payment-method col-4 mt-3">
            <input
              type="radio"
              id="yoco"
              (change)="getPayamnetMethod('yoco')"
              name="payment"
              value="yoco"
            />
            <label for="yoco">Yoco</label>
          </div>
          <div class="col-12 text-center mt-3">
            <button
              class="btn btn-theme fw-bold px-4 py-2 wallet-modal__submit-btn"
              *ngIf="!htmlData"
              [disabled]="!paymentMethod || amount > 999999 || amount <= 0"
              (click)="onProceed()"
            >
              <i class="fa fa-wallet me-2"></i> Proceed to Add Money
            </button>

            <div *ngIf="htmlData" [innerHTML]="htmlData"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
